import _extends from "@babel/runtime/helpers/extends";
import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import Button from "~/components-shared/Button";
import ListenOutsideClick from "../ListenOutsideClick";
const Container = styled.div`
  ${_ref => {
  let {
    $s,
    theme
  } = _ref;
  return theme.spacing.resolve(theme, $s);
}};
  cursor: pointer;
  ${_ref2 => {
  let {
    $fullWidth
  } = _ref2;
  return $fullWidth && "width: 100%";
}};
  position: relative;
  ${_ref3 => {
  let {
    $display
  } = _ref3;
  return $display && `display: ${$display}`;
}};
`;
const ListContainer = styled.div`
  position: fixed;
  z-index: 100;
  margin: 8px 0;
  min-width: ${_ref4 => {
  let {
    offsetWidth
  } = _ref4;
  return offsetWidth;
}}px;
  ${_ref5 => {
  let {
    maxWidth
  } = _ref5;
  return maxWidth && `max-width: ${maxWidth}`;
}};
  ${_ref6 => {
  let {
    minWidth
  } = _ref6;
  return minWidth && `min-width: ${minWidth}`;
}};
  top: ${_ref7 => {
  let {
    direction,
    top,
    bottom
  } = _ref7;
  return direction.toLowerCase().includes("bottom") ? bottom : top;
}}px;
  left: ${_ref8 => {
  let {
    direction,
    left,
    right
  } = _ref8;
  return direction.toLowerCase().includes("right") ? left : right;
}}px;
  transform: translate(
    ${_ref9 => {
  let {
    direction
  } = _ref9;
  return `${direction.toLowerCase().includes("left") ? "-100%" : "0"}, ${direction.toLowerCase().includes("top") ? "calc(-100% - 40px)" : "40px"}`;
}}
  );
  opacity: 0;
  transition: opacity 300ms ease-out, transform 200ms cubic-bezier(0, 0.41, 0.09, 1);
  &.active {
    opacity: 1;
    transform: translate(
      ${_ref10 => {
  let {
    direction
  } = _ref10;
  return `${direction.toLowerCase().includes("left") ? "-100%" : "0"}, ${direction.toLowerCase().includes("top") ? "-100%" : "0"}`;
}}
    );
  }
`;
const List = styled("ul")`
  padding: 0;
  margin: 0 0 1em 0;
  background: ${_ref11 => {
  let {
    theme
  } = _ref11;
  return theme.colors.background.primary;
}};
  box-shadow: ${_ref12 => {
  let {
    theme
  } = _ref12;
  return theme.shadows.middle;
}};
  border-radius: ${_ref13 => {
  let {
    theme
  } = _ref13;
  return theme.shape.borderRadius.primary;
}};
  max-height: ${_ref14 => {
  let {
    $isOpen,
    $maxHeight
  } = _ref14;
  return $isOpen ? $maxHeight : "0";
}};
  box-sizing: border-box;
  overflow: auto;
  transition: all 0.2s ease-out;
  width: ${_ref15 => {
  let {
    $width
  } = _ref15;
  return $width;
}};
  max-width: ${_ref16 => {
  let {
    $width
  } = _ref16;
  return $width;
}};
`;
const ListItem = styled("li")`
  list-style: none;
  padding: 0.75rem 1rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  text-align: left;
  ${_ref17 => {
  let {
    $textWrap
  } = _ref17;
  return !$textWrap && `white-space: nowrap`;
}};
  position: relative;
  transition: background-color 200ms ease-out;

  ${_ref18 => {
  let {
    $selected,
    theme
  } = _ref18;
  return $selected && `background-color: ${theme.colors.action.selected}`;
}};
  ${_ref19 => {
  let {
    $noHover,
    theme
  } = _ref19;
  return !$noHover && `&:hover {
      background-color: ${theme.colors.action.hover};
    }`;
}};

  ${_ref20 => {
  let {
    $sticky
  } = _ref20;
  return $sticky && `position: sticky; top: 0; z-index: 1`;
}};
  ${_ref21 => {
  let {
    $indent
  } = _ref21;
  return $indent > 0 && `padding-left: ${$indent}rem`;
}};
`;
const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
`;
const Dropdown = _ref22 => {
  let {
    s = {},
    initValue = undefined,
    display,
    handler,
    customHandler,
    children,
    onChange = () => false,
    onClose = () => false,
    direction = "bottomRight",
    maxWidth,
    minWidth,
    maxHeight = "360px",
    hasError = false,
    fullWidth = false,
    handlerProps,
    ...rest
  } = _ref22;
  const [isOpen, setIsOpen] = useState(false);
  const [openDirection, setOpenDirection] = useState(direction);
  const [selected, setSelected] = useState(initValue);
  const [params, setParams] = useState({
    top: -999,
    left: -999,
    bottom: -999,
    right: -999,
    offsetWidth: 0,
    offsetHeight: 0
  });
  const containerRef = useRef(null);
  const dropdownRef = useRef(null);
  useEffect(() => {
    setSelected(initValue);
  }, [initValue]);

  // useEffect(() => {
  //   const keyDownHandler = event => {
  //     if (event.key === "Enter") {
  //       event.preventDefault()
  //       onClose()
  //       setIsOpen(false)
  //     }
  //   }
  //
  //   if (isOpen) {
  //     document.addEventListener("keydown", keyDownHandler)
  //   } else {
  //     document.removeEventListener("keydown", keyDownHandler)
  //   }
  //
  //   return () => {
  //     document.removeEventListener("keydown", keyDownHandler)
  //   }
  // }, [isOpen, onClose])

  useEffect(() => {
    const calculatePositioning = () => {
      if (containerRef.current) {
        const {
          offsetWidth,
          offsetHeight
        } = containerRef.current;
        const {
          top,
          left,
          bottom,
          right
        } = containerRef.current.getBoundingClientRect();
        setParams({
          offsetWidth,
          offsetHeight,
          top,
          bottom,
          left,
          right
        });
        const windowHeight = window.innerHeight;
        const windowWidth = window.innerWidth;
        const menuHeight = dropdownRef.current?.offsetHeight || 0;
        const menuWidth = dropdownRef.current?.offsetWidth || 0;
        const initialVertical = direction.includes("top") ? "top" : "bottom";
        const initialHorizontal = direction.includes("Left") ? "Left" : "Right";
        const vertical = top + menuHeight >= windowHeight - 50 && top - menuHeight > 0 ? "top" : initialVertical;
        const horizontal = left + menuWidth >= windowWidth - 50 && left - menuWidth > 0 ? "Left" : initialHorizontal;
        setOpenDirection(`${vertical}${horizontal}`);
      }
    };
    if (isOpen) {
      calculatePositioning();
      document.addEventListener("scroll", calculatePositioning, true);
      window.addEventListener("resize", calculatePositioning, false);
    } else {
      document.removeEventListener("scroll", calculatePositioning);
      window.removeEventListener("resize", calculatePositioning);
    }
    return () => {
      document.removeEventListener("scroll", calculatePositioning);
      window.removeEventListener("resize", calculatePositioning);
    };
  }, [isOpen]);
  const toggle = e => {
    if (e) {
      e.stopPropagation();
    }
    document.body.click();
    setIsOpen(!isOpen);
  };
  const closeSwitcher = () => {
    // ToDo: Side effect this triggers so many times
    onClose();
    setIsOpen(false);
  };
  const onItemClick = value => {
    setSelected(value);
    setIsOpen(false);
    onChange(value);
  };
  return /*#__PURE__*/React.createElement(Container, _extends({
    $display: display,
    $s: s,
    ref: containerRef,
    $fullWidth: fullWidth
  }, rest), customHandler ? customHandler(toggle, isOpen) : /*#__PURE__*/React.createElement(StyledButton, _extends({
    color: "transparent",
    textAlign: "left",
    fullWidth: true,
    onClick: toggle
  }, handlerProps), handler), /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/React.createElement(ListenOutsideClick, {
    onOuterClick: closeSwitcher
  }, /*#__PURE__*/React.createElement(ListContainer, _extends({
    tabIndex: 0,
    role: "listbox",
    direction: openDirection,
    maxWidth: maxWidth,
    minWidth: minWidth,
    ref: dropdownRef,
    className: isOpen ? "active" : undefined
  }, params), typeof children === "function" && children({
    isOpen,
    selected,
    onItemClick
  }))), document.getElementById("dropdown")));
};
Dropdown.List = _ref23 => {
  let {
    isOpen,
    width = "100%",
    maxHeight = "360px",
    children,
    ...rest
  } = _ref23;
  if (!isOpen) {
    return null;
  }
  return /*#__PURE__*/React.createElement(List, _extends({
    role: "listbox",
    $isOpen: isOpen,
    $width: width,
    $maxHeight: maxHeight
  }, rest), children);
};
Dropdown.ListItem = _ref24 => {
  let {
    onClick = () => false,
    children,
    textWrap = false,
    noHover = false,
    selected = false,
    sticky = false,
    indent = 0,
    ...rest
  } = _ref24;
  return /*#__PURE__*/React.createElement(ListItem, _extends({
    role: "option",
    tabIndex: 0,
    "aria-selected": selected,
    $selected: selected,
    $noHover: noHover,
    $textWrap: textWrap,
    $sticky: sticky,
    onClick: onClick,
    $indent: indent
  }, rest), children);
};
export default Dropdown;